import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ValueProps } from './components/ValueProps';
import { ServicesGrid } from './components/ServicesGrid';
import { HowItWorks } from './components/HowItWorks';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServiceArea } from './components/ServiceArea';
import { Reviews } from './components/Reviews';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-navy text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ValueProps data-id="element-4" />
        <ServicesGrid data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <ServiceArea data-id="element-8" />

        <Reviews data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}